import { RepeatIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Cycle = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <RepeatIcon size={Sizes[size]} {...rest} color={fill} />;
};

Cycle.displayName = 'Cycle';
